import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
// import Checkbox from 'react-toolbox/lib/checkbox';
import { List } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import renderIf from 'render-if';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import { statesArray } from 'constants/DropdownsValues';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styless from './Filter.scss';// to import local scss fle

const items = [];
for (let i = 0; i < statesArray.length; i++ ) { //eslint-disable-line
  items.push(<MenuItem value={i} key={i} primaryText={`${statesArray[i]}`} />);
}

const styles = {
  customWidth: {
    width: 180,
  },
  labelStyle: {
    color: '#4a4a4a',
    fontSize: '12px',
    fontWeight: '400',
  },
  iconStyle: {
    color: 'blue',
  },
};

class Filter extends Component {
  static propTypes = {
    updateFilter: PropTypes.func.isRequired,
    toggleFilter: PropTypes.func.isRequired,
    filter: PropTypes.func.isRequired,
    renderFilterSchools: PropTypes.bool.isRequired,
    recommendedDivision: PropTypes.string.isRequired,
    profile: PropTypes.shape.isRequired,
    currentDivision: PropTypes.string.isRequired,
    overrideDivision: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      stateIndex: 0,
      D1: false,
      D2: false,
      D3: false,
      currentState: 'All States',
      divisions: 'All Divisions',
      filterCleared: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.onClickApply = this.onClickApply.bind(this);
    this.onClickClose = this.onClickClose.bind(this);
    this.onClickClear = this.onClickClear.bind(this);
    this.filters = {
    };
  }

  componentDidMount() {
    const { filter } = this.props;
    const that = this;
    if (filter && filter.size > 0) {
      const data = filter.get('data');
      that.setState({ state: filter.get('state') });
      const divisions = data.get('filter_divisions');
      if (List.isList(divisions) && divisions.size > 0) {
        that.filters.filter_divisions = [];
        divisions.forEach((div) => {
          const temp = {};
          temp[div] = true;
          that.setState(temp);
          that.filters.filter_divisions.push(div);
          return div;
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { filter } = nextProps;
    const that = this;
    if (nextProps.filter.size > 0) {
      if (filter.get('clear') === undefined) {
        this.setState({ filterCleared: true });
      } else {
        this.setState({ filterCleared: false });
      }
    }
    if (filter && filter.size > 0) {
      const data = filter.get('data');
      this.setState({ state: filter.get('state') });
      const divisions = data.get('filter_divisions');
      if (List.isList(divisions)) {
        divisions.map((div) => {
          const temp = {};
          temp[div] = true;
          that.setState(temp);
          return null;
        });
      }
    }
  }


  onClickApply() {
    const { profile } = this.props;
    let divisonArray = [];
    if (this.state.currentState === 'All States') {
      const prop = 'state';
      delete this.filters[prop]; // eslint-disable-lint
    }
    divisonArray.push(this.state.divisions);
    if (this.state.divisions === 'All Divisions') {
      if (this.props.recommendedDivision === 'D1' || profile.get('current_division') === 'D1' || profile.get('override_division') === 'D1') {
        divisonArray = ['D1'];
      }

      if (this.props.recommendedDivision === 'D2' || profile.get('current_division') === 'D2' || profile.get('override_division') === 'D2') {
        divisonArray = ['D2', 'D3', 'JUCO', 'NAIA'];
      }
      if (this.props.recommendedDivision === 'D3' || profile.get('current_division') === 'D2' || profile.get('override_division') === 'D2') {
        divisonArray = ['D3', 'JUCO', 'NAIA'];
      }
      if (this.props.recommendedDivision === 'JUCO' || profile.get('current_division') === 'JUCO' || profile.get('override_division') === 'JUCO') {
        divisonArray = ['JUCO', 'NAIA'];
      }
      if (this.props.recommendedDivision === 'NAIA' || profile.get('current_division') === 'NAIA' || profile.get('override_division') === 'NAIA') {
        divisonArray = ['NAIA'];
      }
      this.setState({ filterCleared: true });
    }
    this.filters['filter_divisions'] = divisonArray; //eslint-disable-line
    let sendStates = this.state.currentState;
    if (this.state.currentState === 'All States') {
      sendStates = '';
      // this.filters.filter_divisions = [];
    }
    this.props.updateFilter({ data: this.filters, apply: true, state: sendStates });
  }
  onClickClear() {
    this.props.updateFilter({ data: {}, apply: true, state: '', clear: true });
    this.setState({ filterCleared: false, stateIndex: 0, divisions: 'All Divisions', currentState: 'All States' });
    // this.props.toggleFilter();
  }

  onClickClose() {
    this.props.updateFilter({ data: this.filters, apply: false, state: this.state.state });
    this.props.toggleFilter();
  }


  handleStateChange(event, index, value) {
    this.setState({ currentState: statesArray[value], stateIndex: index });
    if (statesArray[value] !== 'All States') {
      if (statesArray[value] === 'Washington D.C') {
        this.filters.state = 'D.C.';
      } else {
        this.filters.state = statesArray[value];
      }
    }
  }

  handleChange = (event, index, value) => {
    this.setState({ divisions: value });
  };

  render() {
    const { filterCleared } = this.state;
    const { recommendedDivision, renderFilterSchools, currentDivision,
      overrideDivision } = this.props;
    const renderClearFilter = renderIf(filterCleared);
    if (!renderFilterSchools) {
      return null;
    }

    let disableD1 = (recommendedDivision === 'D2' || recommendedDivision === 'D3' ||
                        recommendedDivision === 'NAIA' || recommendedDivision === 'JUCO' ||
                        currentDivision === 'D2' || currentDivision === 'D3' ||
                        currentDivision === 'NAIA' || currentDivision === 'JUCO' ||
                        overrideDivision === 'D2' || overrideDivision === 'D3'
                      );
    let disableD2 = (recommendedDivision === 'D3' || recommendedDivision === 'NAIA' ||
                      recommendedDivision === 'JUCO' || currentDivision === 'D3' || currentDivision === 'NAIA'
                      || currentDivision === 'JUCO' || overrideDivision === 'D3');

    let disableD3 = (recommendedDivision === 'NAIA' || recommendedDivision === 'JUCO' ||
                       currentDivision === 'NAIA' || currentDivision === 'JUCO');

    const disableNaia = (recommendedDivision === 'JUCO' || currentDivision === 'JUCO');

    if (overrideDivision === 'D1') disableD1 = false;
    if (overrideDivision === 'D2') disableD2 = false;
    if (overrideDivision === 'D2') disableD3 = false;

    return (
      <div className={cn('col s12', styless.containerFilter)}>
        <div className={cn('col s12 m8')}>
          <div className={cn('col s6 m4', styless.removePadding)}>
            <DropDownMenu
              className={styless.removePadding}
              value={this.state.stateIndex}
              onChange={this.handleStateChange}
              style={styles.customWidth}
              autoWidth={false}
              labelStyle={styles.labelStyle}
              maxHeight={300}
              iconStyle={styles.iconStyle}
            >
              {items}
            </DropDownMenu>
          </div>
          <div className={cn('col s5 m4', styless.removePadding)}>
            <DropDownMenu
              value={this.state.divisions}
              onChange={this.handleChange}
              style={styles.customWidth}
              labelStyle={styles.labelStyle}
              autoWidth={false}
              iconStyle={styles.iconStyle}
            >
              <MenuItem
                value={'All Divisions'}
                primaryText="All Divisions"
              />
              <MenuItem
                value={'D1'}
                disabled={disableD1}
                // disabled={(recommendedDivision === 'D2' || recommendedDivision === 'D3' ||
                // recommendedDivision === 'JUCO' ||
                // recommendedDivision === 'NAIA') ? true : false} // eslint-disable-line
                primaryText="Division 1"
              />
              <MenuItem
                value={'D2'}
                disabled={disableD2}
                primaryText="Division 2"
              />
              <MenuItem
                value={'D3'}
                disabled={disableD3}
                primaryText="Division 3"
              />
              <MenuItem
                value={'NAIA'}
                disabled={disableNaia}
                primaryText="NAIA"
              />
              <MenuItem
                value={'JUCO'}
                primaryText="JUCO"
              />
            </DropDownMenu>
          </div>
          {renderClearFilter(
            <div className={cn('col s4', styless.clearFilter)} >
              <button onClick={this.onClickClear}>CLEAR FILTER</button>
            </div>)}
        </div>
        <div className={cn('col s12 m4', styless.applyButton)}>
          <button onClick={this.onClickClose}>CLOSE</button>
          <button className={styless.apply} onClick={this.onClickApply}>APPLY</button>
        </div>
        <div className={cn('col s12', styless.filterInSmall)}>
          <div className={cn('col s4')}>
            <button onClick={this.onClickClose} className={styless.closeButtonInSmall}>
              CLOSE</button>
          </div>
          <div className={cn('col s4')}>
            {renderClearFilter(
              <button onClick={this.onClickClear} className={styless.clearFilterForSmall}>
                  CLEAR
              </button>,
              )}
          </div>
          <div className={cn('col s4')}>
            <button onClick={this.onClickApply} className={styless.applyButtonInSmall}>
              APPLY</button>
          </div>
        </div>
      </div>
    );
  }
}

export default Filter;




// WEBPACK FOOTER //
// ./src/components/Filter/Filter.js